import { Skeleton, Stack } from "@mui/material";

type Props = {};

const CustomerTableLoading = (props: Props) => {
  return (
    <Stack spacing={2} justifyContent="center">
      <Skeleton
        variant="rectangular"
        animation="wave"
        height={60}
        width="100%"
      />
      <Skeleton
        variant="rectangular"
        animation="wave"
        height={60}
        width="100%"
      />
      <Skeleton
        variant="rectangular"
        animation="wave"
        height={60}
        width="100%"
      />
      <Skeleton
        variant="rectangular"
        animation="wave"
        height={60}
        width="100%"
      />
    </Stack>
  );
};

export default CustomerTableLoading;
